/* Recência — "este item foi publicado agora", não "este item está disponível".
 *
 * Antes, `nova` significava as duas coisas ao mesmo tempo, e por isso a estrela
 * carimbava toda jornada liberada desde o primeiro minuto do evento. Num evento
 * de dois dias, "nova" em tudo não informa nada.
 *
 * A janela é curta de propósito: o marcador serve para o produtor publicar algo
 * durante o evento e o participante notar. Passado o prazo, ele desaparece sem
 * intervenção — e o chip de filtro correspondente desaparece com ele, porque
 * `visibleFilterOptions` não renderiza filtro sem itens. */

export const RECENT_WINDOW_HOURS = 1

export const RECENT_WINDOW_MS = RECENT_WINDOW_HOURS * 60 * 60 * 1000

/**
 * `now` é parâmetro, não `Date.now()` interno, por duas razões:
 *
 * 1. **Teste determinístico.** A suíte roda em `environment: 'node'` sem fake
 *    timers configurados; um relógio interno tornaria os casos de fronteira
 *    dependentes do momento da execução.
 * 2. **Coerência dentro da lista.** O hook captura o instante uma vez por
 *    render e passa o mesmo valor para todos os itens. Sem isso, dois itens
 *    criados no mesmo segundo poderiam ser avaliados contra instantes
 *    diferentes na mesma renderização.
 */
export const isRecent = (
  createdAt: string | null | undefined,
  now: number
): boolean => {
  if (!createdAt) return false

  const created = Date.parse(createdAt)

  // Recurso sem `created_at` utilizável simplesmente não tem o conceito —
  // devolver `false` evita um branch especial em cada consumidor.
  if (Number.isNaN(created)) return false

  const elapsed = now - created

  // Negativo = timestamp no futuro. Relógio do cliente adiantado não deve
  // carimbar a lista inteira como nova.
  if (elapsed < 0) return false

  return elapsed < RECENT_WINDOW_MS
}
